


































































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Qrpage from "../components/Qrpage.vue";
import axios from "axios";
import config from "../config";
import vSelect from "vue-select";

@Component({components: {
    Qrpage,
    vSelect,
}})
export default class InventoryEditItem extends Vue {
  @Prop({default: null}) item !: any;
  @Prop({default: null}) manufacturers!: any;
  @Prop({default: null}) nomenclatures!: any;
  @Prop({default: null}) models!: any;
  @Prop({default: null}) control_no !: string;
  @Prop({default: null}) manufacturer !: string;
  @Prop({default: null}) nomenclature !: string;
  @Prop({default: null}) model !: string;
  @Prop({default: null}) serial_no !: string;

  @Prop({default: false}) manualManufacturer !: boolean;
  @Prop({default: false}) manualNomenclature !: boolean;
  @Prop({default: false}) manualModel !: boolean;

  @Prop({default: false}) clientId !: string;
  @Prop({default: ""}) location !: string;
  @Prop({default: false}) pm !: boolean;
  @Prop({default: "annual"}) frequency !: string;
  @Prop({default: "January"}) startingMonth !: string;
  @Prop({default: false}) safetyTest !: boolean;

  @Prop({ default: null }) inventoryList!: any;
  @Prop({ default: null }) clients!: any;

  inv: {
    controlNo: string;
    manufacturer: string;
    nomenclature: string;
    model: string;
    qrserialNo: string;
    clientId: string;
    location: string;
    pm: boolean;
    frequency: string;
    startingMonth: string;
    safetyTest: boolean;
  } = {
    controlNo: this.control_no,
    manufacturer: this.manufacturer,
    nomenclature: this.nomenclature,
    model: this.model,
    qrserialNo: this.serial_no,
    clientId: this.clientId,
    location: this.location,
    pm: this.pm,
    frequency: this.frequency || "annual",
    startingMonth: this.startingMonth || "January",
    safetyTest: this.safetyTest,
  };

  selectedClient: any = null;

  // Guards the manufacturer/nomenclature cascading-reset watchers below
  // while the item.* watchers are applying a freshly reopened row's fields.
  // Without it, reopening the modal on a different row races the cascade
  // meant for manual dropdown changes and wipes the row's real
  // nomenclature/model back to "" (see mequidox-main#23).
  isApplyingItemProps = false;

  @Watch('inv.clientId')
  onClient(clientId) {
    for (const i in this.clients) {
      const client = this.clients[i];
      if (client.clientId === clientId) {
        this.selectedClient = client;
        break;
      }
    }
  }

  @Watch('item.controlNo')
  onControlChange(val: any) {
    this.inv.controlNo = val;
  }

  @Watch('item.manufacturer')
  onManufacturerChange(val: any) {
    this.isApplyingItemProps = true;
    this.inv.manufacturer = val;
    this.$nextTick(() => { this.isApplyingItemProps = false; });
  }

  @Watch('item.nomenclature')
  onNomenclatureChange(val: any) {
    this.isApplyingItemProps = true;
    this.inv.nomenclature = val;
    this.$nextTick(() => { this.isApplyingItemProps = false; });
  }

  @Watch('item.model')
  onModelChange(val: any) {
    this.isApplyingItemProps = true;
    this.inv.model = val;
    this.$nextTick(() => { this.isApplyingItemProps = false; });
  }

  @Watch('item.qrserialNo')
  onQRChange(val: any) {
    this.inv.qrserialNo = val;
  }

  @Watch('item.location')
  onLocationChange(val: any) {
    this.inv.location = val;
  }

  @Watch('item.pm')
  onPmChange(val: any) {
    this.inv.pm = val;
  }

  @Watch('item.frequency')
  onFrequencyChange(val: any) {
    this.inv.frequency = val || "annual";
  }

  @Watch('item.startingMonth')
  onStartingMonthChange(val: any) {
    this.inv.startingMonth = val || "January";
  }

  @Watch('item.safetyTest')
  onSafetyTestChange(val: any) {
    this.inv.safetyTest = val;
  }

  created() {
    this.$root.$on('bv::modal::show', () => {
      this.inventoryList.forEach((item: any) => {
        if (this.inv.manufacturer !== item.Manufacturer) return;

        if (!this.nomenclatures.includes(item.Nomenclature)) this.nomenclatures.push(item.Nomenclature);
      });

      this.inventoryList.forEach((item: any) => {
        if (this.inv.nomenclature !== item.Nomenclature) return;

        if (!this.models.includes(item.Model)) this.models.push(item.Model);
      });

      for (const i in this.clients) {
        const client = this.clients[i];
        if (client.clientId === this.inv.clientId) {
          this.selectedClient = client;
          break;
        }
      }
    })
  }

  @Watch('inv.manufacturer')
  onInventoryManufacturer(manufacturer) {
    if (this.isApplyingItemProps) return;

    this.nomenclatures = [];
    if (!this.manualNomenclature) this.inv.nomenclature = '';
    if (!this.manualModel) this.inv.model = '';

    this.inventoryList.forEach((item: any) => {
      if (manufacturer !== item.Manufacturer) return;

      if (!this.nomenclatures.includes(item.Nomenclature)) this.nomenclatures.push(item.Nomenclature);
    });

    console.log(this.nomenclatures);
  }

  @Watch('inv.nomenclature')
  onInventoryModel(nomenclature) {
    if (this.isApplyingItemProps) return;

    this.models = [];
    if (!this.manualModel) this.inv.model = '';

    this.inventoryList.forEach((item: any) => {
      if (nomenclature !== item.Nomenclature) return;

      if (!this.models.includes(item.Model)) this.models.push(item.Model);
    });
  }

  decodedString !: string;

  $isMobile!:any;

  isQrEnabled = this.$isMobile();
  isUpdateFailed = false;
  errorMessage = false;

  public onDecode(decodedString : string) : void {
    this.inv.qrserialNo = decodedString;
  }

  public async save(): Promise<void> {
    this.isUpdateFailed = false;

    if (!this.inv.clientId || !this.selectedClient) {
      this.isUpdateFailed = true;
      return;
    }

    const invAdd = {
      manufacturer: this.inv.manufacturer,
      nomenclature: this.inv.nomenclature,
      model: this.inv.model,
      qrserialNo: this.inv.qrserialNo,
      controlNo: this.inv.controlNo,
      manualManufacturer: this.manualManufacturer,
      manualNomenclature: this.manualNomenclature,
      manualModel: this.manualModel,
      clientId: this.inv.clientId,
      location: this.inv.location,
      pm: this.inv.pm,
      frequency: (this.inv.pm || this.inv.safetyTest) ? this.inv.frequency : "",
      startingMonth: (this.inv.pm || this.inv.safetyTest) ? this.inv.startingMonth : "",
      safetyTest: this.inv.safetyTest,
    };

    const response: any = await axios({
      method: 'post',
      url: config.apiEndpoint + "inventory/" + this.item.inventoryId,
      data: invAdd,
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.$store.state.authentication.token,
        'x-access-token': this.$store.state.authentication.token
      },
    });

    const success = response.data.success;

    if (success) {
      this.$bvModal.hide('ModalEditItem-' + this.item.ID);
      this.$emit('fetchInventoryList');
    }
    else {
      this.isUpdateFailed = true;
      this.errorMessage = response.data.msg;
    }
  }

}
